module.exports = __webpack_public_path__ + "static/media/426.899e7b77.png";